import http from "../http";

export const getTrust = (storeId) => {
  return http.get(`/store-management/trust/?store_id=${storeId}`);
};

export const saveStoreTrust = (data) => {
  return http.post(`/store-management/trust/`, data);
};
